export const isBetween = (number: number, min: number, max: number): boolean => (number >= min && number <= max);

export default undefined;